"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../../utils");
/**
 * Class to handle all review QA log data parsing and formatting
 */
class ReviewQALogParser {
    constructor(reviews) {
        if (reviews.length < 1) {
            throw Error("QA Log requires data to be at least length 1");
        }
        this._reviews = reviews;
        this._parsedSampleRuns = this._parse();
        this._formattedSampleRuns = this._format();
    }
    _parse() {
        const { _reviews } = this;
        const sampleRuns = new Array();
        _reviews.forEach((review) => {
            const { samples } = review;
            samples.forEach((sampleReview) => {
                sampleRuns.push({
                    reviewerName: review.reviewerName,
                    date: review.date,
                    sampleName: sampleReview.sampleName,
                    sampleType: sampleReview.sampleType,
                    runId: review.runId,
                    run: review.run,
                    pcrEquipmentId: review.pcrEquipmentId,
                    experimentId: review.experimentId,
                    protocolId: review.protocolId,
                    protocol: review.protocol,
                    comments: sampleReview.comments,
                    status: sampleReview.passed,
                    result: sampleReview.overallResult,
                    failureReason: sampleReview.failureReason,
                });
            });
        });
        return sampleRuns;
    }
    _format() {
        return this._parsedSampleRuns.map((sampleRun) => (Object.assign(Object.assign({}, sampleRun), { status: sampleRun.status ? "PASS" : "FAIL", failureReason: sampleRun.failureReason ? sampleRun.failureReason : "N/A", experimentId: sampleRun.experimentId ? sampleRun.experimentId : "N/A", comments: sampleRun.comments && sampleRun.comments.length > 0
                ? sampleRun.comments
                : "N/A", date: (0, utils_1.SQLTimestampToDate)(sampleRun.date) })));
    }
    getFormattedSampleRuns() {
        return this._formattedSampleRuns;
    }
}
exports.default = ReviewQALogParser;
